export class GlobalConfig {
  static countryCode = 'bn';
}
